/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFulfillmentSchedulingQuote} from '../api'

 export const useQueryGetFulfillmentSchedulingQuote = createReactQueryHook('getFulfillmentSchedulingQuote', getFulfillmentSchedulingQuote)
